import { Erro } from "../StatusIcones/erro";
import { Finalizado } from "../StatusIcones/finalizado";
import { Play } from "../StatusIcones/play";
import { Processando } from "../StatusIcones/processando";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { Indisponivel } from "../StatusIcones/indisponivel";
import { HttpResponse } from "_services/api/HttpResponse";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";
import { Atencao } from "../StatusIcones/atencao";

interface HandleStatusGerarProcessoProps {
  etapa: EtapaGerenciarEmplacamentosEnum;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  gerarProcesso: (id: number) => Promise<HttpResponse>;
  idProcesso: number;
  dados: IListarEmplacamentosPR[];
  setDados: (dados: IListarEmplacamentosPR[]) => void;
  setTooltipLeft: (left: number) => void;
  setTooltipTop: (top: number) => void;
  setTooltipConteudo: (conteudo: string | JSX.Element) => void;
  setTooltipWidth: (width: number) => void;
  setShowTooltip: (show: boolean) => void;
  abrirModalGerarProcessoManualmenteOuAutomaticamente: (
    id: number,
    mensagemErro: string
  ) => void;
  mensagemErro: string;
  habilitarEscolhaPlaca: boolean;
  codigoDeBarras: NullableString;
}
export function HandleStatusGerarProcesso({
  etapa,
  status,
  gerarProcesso,
  idProcesso,
  dados,
  setDados,
  setTooltipLeft,
  setTooltipTop,
  setTooltipConteudo,
  setTooltipWidth,
  setShowTooltip,
  abrirModalGerarProcessoManualmenteOuAutomaticamente,
  mensagemErro,
  habilitarEscolhaPlaca,
  codigoDeBarras,
}: HandleStatusGerarProcessoProps) {
  const handleStatus = (
    status: StatusEtapaGerenciarEmplacamentosEnum,
    mensagem?: string
  ) => {
    dados.forEach((processo) => {
      if (processo.id == idProcesso) {
        processo.statusEtapa = status;
        processo.etapa = EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO;

        if (mensagem) {
          processo.observacao = mensagem;
        }
      }
    });
    setDados(dados);
  };

  const onClick = async () => {
    abrirModalGerarProcessoManualmenteOuAutomaticamente(
      idProcesso,
      "Escolha como gerar processo"
    );

    setShowTooltip(false);
    setTooltipLeft(0);
    setTooltipTop(0);
    setTooltipConteudo("");
  };

  const etapaGerarProcessoConcluida = (
    etapaAvaliar: EtapaGerenciarEmplacamentosEnum,
    statusAvaliar: StatusEtapaGerenciarEmplacamentosEnum
  ): boolean => {
    const etapasAteGerarProcesso = [
      EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA,
      EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO,
    ];

    if (!etapasAteGerarProcesso.includes(etapaAvaliar)) {
      return true;
    }

    if (
      etapaAvaliar == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO &&
      statusAvaliar == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO
    ) {
      return true;
    }

    return false;
  };

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.PAGAR_TAXA,
    EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA,
    EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO,
    EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA,
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL,
  ];

  if (
    (!etapa ||
      (etapa == EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA &&
        status != StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)) &&
    habilitarEscolhaPlaca
  ) {
    return <Indisponivel />;
  }

  if (!codigoDeBarras && etapaGerarProcessoConcluida(etapa, status)) {
    return (
      <Atencao
        onClick={abrirModalGerarProcessoManualmenteOuAutomaticamente}
        id={idProcesso}
        mensagem={
          mensagemErro ??
          "Atenção: Processo gerado, porém não contém código de barras."
        }
      />
    );
  }

  if (
    (etapa && etapasPosteriores.includes(etapa)) ||
    (etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO &&
      status == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)
  ) {
    return <Finalizado />;
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.ERRO
  ) {
    return (
      <Erro
        onClick={() =>
          abrirModalGerarProcessoManualmenteOuAutomaticamente(
            idProcesso,
            mensagemErro
          )
        }
      />
    );
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO &&
    status == StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO
  ) {
    return (
      <Processando
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
      />
    );
  }

  return <Play acao={onClick} />;
}
